
<script>
import {
  consultarCitasPaciente,
  cancelarCita,
  sendNotification,
  switchToInvoice,
} from "../../apiService/request/Agendamiento";
import moment from "moment";
import Agendamiento from "../Agendamiento/Agendamiento";
import metodos_comunes from "../../js/metodos_comunes";
import mixinScroll from "../../js/mixins/mixinScroll";

export default {
  data: () => ({
    confirmarCita: true,
    mostrarAgenadamiento: false,
    indexCancelar: -1,
    agendamiento: 0,
    datosreagendar: {},
    reagendar: false,
    page: 1,
    search: "",
    items: {},
    itemsPerPage: 3,
    tarjeta: 0,
    items: [
      { text: "Hoy", value: 0 },
      { text: "Todas", value: 12 },
    ],
    sedes: [{ sede: "medellin" }, { sede: "rionegro" }],
    paso: 0,
    valorSeleccionado: 0,
    informacionCitas: [],
    citaSeleccionada: null,
    sedeSelecionada: "",
    pacienteNoAsistio: -1,
    confirmarEnviarNotificacion: -1,
    appointmentSelected: [],
    indexAppointmentSelected: -1,
    confirmInvoice: -1,
  }),
  created() {
    this.consultarCitas();
  },
  components: {
    Agendamiento,
  },
  filters: {
    moment: function (date, format) {
      return moment(date).format(format);
    },
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.informacionCitas.length / this.itemsPerPage);
    },
  },
  watch: {
    valorSeleccionadoDialogo(valor) {
      if (valor == "Si") {
        if (this.indexCancelar >= 0) {
          this.cancelarCita(this.indexCancelar);
        } else if (this.pacienteNoAsistio >= 0) {
          this.cancelarCita(this.pacienteNoAsistio);
        } else if (this.confirmarEnviarNotificacion >= 0) {
          this.sendNotification(this.appointmentSelected);
        } else if (this.confirmInvoice >= 0) {
          this.sendInvoice(this.appointmentSelected);
        }
      } else if (valor === "No") {
        if (this.indexCancelar >= 0) {
          this.indexCancelar = -1;
        }
        if (this.pacienteNoAsistio >= 0) {
          this.pacienteNoAsistio = -1;
        }
        if (this.confirmarEnviarNotificacion >= 0) {
          this.confirmarEnviarNotificacion = -1;
          this.appointmentSelected = [];
        }
        if (this.confirmInvoice >= 0) {
          this.confirmInvoice = -1;
          this.appointmentSelected = [];
        }
      }
    },
  },
  props: {
    valorSeleccionadoDialogo: {
      type: String,
      default: "",
    },
  },
  mixins: [mixinScroll],
  methods: {
    responseEnponidsMessage(dataResponse) {
      this.$store.dispatch("setCargando", false);
      const dialogoModal = {
        status: dataResponse.data.status,
        dialogo: false,
        data: {
          message: dataResponse.data.message,
        },
      };
      if (dialogoModal.status == 200) {
        this.limpiarData();
        this.volver();
      }
      this.$store.dispatch("cambiarEstadoModal", true);
      this.$store.dispatch("cambiarMensajeModal", dialogoModal);
      this.$store.dispatch(
        "setMensajeChatBox",
        this.$store.getters.getCedulaPaciente
      );
    },
    async sendInvoice() {
      this.$store.dispatch("setCargando", true);
      let response = null;
      try {
        response = await switchToInvoice(
          this.appointmentSelected.documento,
          this.$store.state.provider_email,
          this.appointmentSelected.cups,
          'asignada',
          [
            {
              nombre: "za01724f9a",
              valor: "factura",
            },
          ]
        );
      } catch (error) {
        console.log(error);
      } finally {
       this.responseEnponidsMessage(response);
      }
    },
    confirmSendInvoice(appointmentData) {
      const dialogoModal = {
        dialogo: true,
        mensaje: `¿Está seguro de que desea cambiar el estado de la orden?`,
        opciones: ["Si", "No"],
        status: 200,
      };
      this.$store.dispatch("cambiarEstadoModal", true);
      this.$store.dispatch("cambiarMensajeModal", dialogoModal);
      this.confirmInvoice = 1;
      this.appointmentSelected = appointmentData;
    },
    limpiarData() {
      if (this.indexCancelar >= 0) {
        this.indexCancelar = -1;
      }
      if (this.pacienteNoAsistio >= 0) {
        this.pacienteNoAsistio = -1;
      }
      if (this.confirmarEnviarNotificacion >= 0) {
        this.confirmarEnviarNotificacion = -1;
        this.appointmentSelected = [];
      }
      if (this.confirmInvoice >= 0) {
        this.confirmInvoice = -1;
        this.appointmentSelected = [];
      }
    },
    sendMeesaConfirmationNotification(appointmentData) {
      const dialogoModal = {
        dialogo: true,
        mensaje: `¿Está seguro de que desea enviar la notificación?`,
        opciones: ["Si", "No"],
        status: 200,
      };
      this.$store.dispatch("cambiarEstadoModal", true);
      this.$store.dispatch("cambiarMensajeModal", dialogoModal);
      this.confirmarEnviarNotificacion = 1;
      this.appointmentSelected = appointmentData;
    },
    async sendNotification(appointmentData) {
      let response = null;
      try {
        this.$store.dispatch("setCargando", true);
        response = await sendNotification(
          this.$store.state.provider_email,
          appointmentData.nombrePaciente,
          appointmentData.evento,
          appointmentData.documento,
          appointmentData.responsable,
          appointmentData.ordenId,
          appointmentData.fechaHoraCita
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.responseEnponidsMessage(response);
      }
    },
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    verCitaSeleccionada(index, cups) {
      this.citaSeleccionada = this.informacionCitas[index];
      this.$store.dispatch("setMensajeChatBox", cups);
      this.indexAppointmentSelected = index;
    },
    async consultarCitas() {
      const respuesta = await consultarCitasPaciente(
        this.$store.getters.getCedulaPaciente,
        "reservado",
        this.valorSeleccionado
      );
      this.informacionCitas = respuesta.data.data;
    },
    enviarNotificacion(cups) {
      this.$store.dispatch("setMensajeChatBox", "Enviar Notificacion");
    },
    async confirmaCancelarCita(index) {
      this.indexCancelar = index;
      const dialogoModal = {
        dialogo: true,
        mensaje: `¿Está seguro de que desea reagendar esta cita?`,
        opciones: ["Si", "No"],
        status: 200,
      };
      this.$store.dispatch("cambiarEstadoModal", true);
      this.$store.dispatch("cambiarMensajeModal", dialogoModal);
    },
    pacienteNoAsiste() {
      const dialogoModal = {
        dialogo: true,
        mensaje: `¿Está seguro que el paciente no asistió?`,
        opciones: ["Si", "No"],
        status: 200,
      };
      this.$store.dispatch("cambiarEstadoModal", true);
      this.$store.dispatch("cambiarMensajeModal", dialogoModal);
      this.pacienteNoAsistio = this.indexAppointmentSelected;
    },
    volver() {
      this.citaSeleccionada = null;
      this.pacienteNoAsistio = -1;
    },
    async cancelarCita(index) {
      try {
        const respuesta = await cancelarCita(
          this.$store.getters.getCedulaPaciente,
          this.informacionCitas[index].ordenId,
          this.$store.state.provider_email
        );
        this.$store.dispatch("cambiarEstadoModal", true);
        this.$store.dispatch("cambiarMensajeModal", respuesta);
        if (this.pacienteNoAsistio === -1) {
          this.datosreagendar = respuesta.data.data[0];
          this.reagendar = true;
        }
        this.citaSeleccionada = null;
      } catch (err) {
        console.log(err);
      } finally {
        this.consultarCitas();
      }
    },
    reagendamiento() {
      try {
        this.$store.dispatch(
          "setSede",
          metodos_comunes.reemplazarCaracteresEspeciales(this.sedeSelecionada)
        );
        this.$store.dispatch("setEvento", this.datosreagendar.key);
        this.$store.dispatch("setOrdenId", this.datosreagendar.ordenId);
        this.$store.dispatch(
          "setNombrePrestacion",
          this.datosreagendar.nombrePrestacion
        );
        this.$store.dispatch("setCups", this.datosreagendar.cups);
      } catch (err) {
        console.log(err);
      } finally {
        this.mostrarAgenadamiento = true;
        this.agendamiento += 1;
        this.autoScroll("contenedorAgendamiento", "item2Comprimido", 80);
        // setTimeout( () => {
        //   this.autoScroll ( 'contenedorAgendamiento', 'item2Comprimido', 80 );
        // }, 400);
      }
      // this.$store.dispatch("setSede",metodos_comunes.reemplazarCaracteresEspeciales(this.sedeSelecionada))
      // this.$store.dispatch("setEvento",this.datosreagendar.key)
      // this.agendamiento += 1;
      // this.posicionAgendamiento();
    },
    // posicionAgendamiento() {
    //   let scrollAgendamiento = document.getElementById('contenedorAgendamiento').offsetTop;
    //   let item2Comprimido = document.getElementsByClassName("item2Comprimido");
    //   item2Comprimido[0].scrollTop = scrollAgendamiento;
    // },
    mostrarAgenadamientoConfirmaCita() {
      this.sedeSelecionada = "";
      this.reagendar = false;
      this.mostrarAgenadamiento = false;
      this.consultarCitas();
    },
  },
};
</script>
<template src="./ConfirmarCita.html"></template>
<style lang="scss" src="./ConfirmarCita.scss"></style>


// WEBPACK FOOTER //
// src/components/ConfirmarCita/ConfirmarCita.vue